import {
  invoiceDraftRequestSchema,
  type InvoiceDraftRequest,
  type InvoiceDraftResponse,
} from "@stb/api-contract"
import { createServerFn } from "@tanstack/react-start"

import { proposeInvoiceDraft } from "@/assistant/invoice-draft-run.server"

import { runAction, type RpcResult } from "./context"

/**
 * "Say it" (T472, spec R2.10): the page sends the dictated text, the server returns a PROPOSAL
 * (nothing is stored; the text is not kept). The user checks the filled form and saves it with
 * the normal `createInvoiceAction`, which is where the invoice quota is counted, once.
 * Parsing is feature-guarded by `runInvoiceDraft` (`invoicing`) and uses the assistant's own
 * monthly turn counter, not the invoice quota.
 */
export const proposeInvoiceDraftAction = createServerFn({ method: "POST" })
  .validator((data: InvoiceDraftRequest) => invoiceDraftRequestSchema.parse(data))
  .handler(async ({ data }): Promise<RpcResult<InvoiceDraftResponse>> =>
    runAction(({ context }) => proposeInvoiceDraft(context, data, "web")),
  )
